// @ts-nocheck
import React, { useEffect, useState } from 'react'
import Upload from './Upload'
import Dropdown from 'components/common/Dropdown'
import AutocompleteWithDropdown from './AutocompleteWithDropdown'
import { Controller } from 'react-hook-form'
import {
	StyledTitleGrid,
	StyledSubTitleGrid,
	StyledTitle,
	StyledSubTitle,
	StyledFieldsContainer,
	StyledGridContainerForTextFields,
	StyledDisclaimer,
} from './contact-us-styles'
import { sendRequest, getLocaleStr, codeToLocale } from 'utils/utils'
import TextField from 'components/common/TextField'
import { tenantUrls, TenantUrlPickOptions } from 'utils/api/storefrontUrls'

const buildContactUsFormConstants = (lang) => {
	const dropdownOptions = {
		[`${lang.webviewFlow.pleaseChooseWayOfOrder} *`]: [
			lang.webviewFlow.inTheRestaurant,
			lang.webviewFlow.takeAway,
			lang.webviewFlow.deliveryOrder,
			lang.webviewFlow.notAvailable,
		],
		[lang.webviewFlow.pleaseChooseRestaurant]: [],
		[`${lang.webviewFlow.pleaseSelectTopic} *`]: [
			lang.webviewFlow.positiveFeedback,
			lang.webviewFlow.complaint,
			lang.webviewFlow.question,
			lang.webviewFlow.idea,
		],
		[`${lang.webviewFlow.pleaseChooseAreaOfMessage} *`]: [
			lang.webviewFlow.accuracyOfOrder,
			lang.webviewFlow.speedOfService,
			lang.webviewFlow.productQuality,
			lang.webviewFlow.webOrdering,
			lang.webviewFlow.Friendliness,
			lang.webviewFlow.Payment,
			lang.webviewFlow.cleanliness,
			lang.webviewFlow.productAvailability,
			lang.webviewFlow.other,
		],
	}
	const dropdownFieldNames = [
		`${lang.webviewFlow.pleaseChooseWayOfOrder} *`,
		lang.webviewFlow.pleaseChooseRestaurant,
		`${lang.webviewFlow.pleaseSelectTopic} *`,
		`${lang.webviewFlow.pleaseChooseAreaOfMessage} *`,
	]

	const fieldNameToValidationMap = {
		[`${lang.webviewFlow.pleaseChooseWayOfOrder} *`]: 'orderType',
		[lang.webviewFlow.pleaseChooseRestaurant]: 'store',
		[`${lang.webviewFlow.pleaseSelectTopic} *`]: 'topic',
		[`${lang.webviewFlow.pleaseChooseAreaOfMessage} *`]: 'areaOfMessage',
	}
	return [dropdownOptions, dropdownFieldNames, fieldNameToValidationMap]
}

const ContactUsForm = ({ control, register, getValues, clearErrors, setValue, setError, chainId, branchesList = [], lang, languageForLocale }) => {
	const gridProps = { xs: 6, sm: 6, md: 6, lg: 6 }
	const [storeList, setStoreList] = useState(null)
	const [dropdownOptions, dropdownFieldNames, fieldNameToValidationMap] = buildContactUsFormConstants(lang)
	const locale = codeToLocale[languageForLocale]

	useEffect(() => {
		const getStoreList = async () => {
			if (branchesList.msg) {
				const storeTitles = branchesList.msg.map((store) => getLocaleStr(store.title, locale))
				setStoreList([...storeTitles, lang.webviewFlow.noReferenceToSpecificStore])
			} else if (chainId) {
				const urls = await tenantUrls([TenantUrlPickOptions.WebFlowAddressURL])

				const getBranchesListRes = await sendRequest(
					false,
					`${urls.webFlowAddressURL}&xrs=ewcuf`,
					'post',
					{
						chainId,
						lang: 'en',
						type: 'getBranchesList',
						cust: 'openRest',
					},
					{
						'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
					},
					true,
					90000,
					null,
					false
				)

				if (getBranchesListRes.msg) {
					const storeTitles = getBranchesListRes.msg.map((store) => getLocaleStr(store.title, locale))
					setStoreList([...storeTitles, lang.webviewFlow.noReferenceToSpecificStore])
				}
			}
		}
		getStoreList()
	}, [])

	return (
		<>
			<StyledTitleGrid item xs={12} sm={12} md={12}>
				<StyledTitle variant="h1" ignoreRTL showLowerDivider testId="contact-us-title">
					{lang.webviewFlow.contactCustomerCareTeam}
				</StyledTitle>
				{/* <StyledDivider id="contact_us_divider" /> */}
			</StyledTitleGrid>
			<StyledSubTitleGrid item xs={12} sm={12} md={12}>
				<StyledSubTitle component="p" variant="Subhead">
					{lang.webviewFlow.theOpinionOfOurGuests}
				</StyledSubTitle>
			</StyledSubTitleGrid>

			<StyledFieldsContainer container>
				<Controller
					control={control}
					name="firstName"
					defaultValue=""
					render={({ field, fieldState: { invalid, error } }) => (
						<StyledGridContainerForTextFields item {...gridProps}>
							<TextField
								label={lang.webviewFlow.firstName}
								required
								field={field}
								error={invalid}
								errorMessage={error?.message}
								inputProps={{ maxLength: 32, 'data-testid': 'first-name-input' }}
							/>
						</StyledGridContainerForTextFields>
					)}
				/>

				<Controller
					control={control}
					name="lastName"
					defaultValue=""
					render={({ field, fieldState: { invalid, error } }) => (
						<StyledGridContainerForTextFields item {...gridProps}>
							<TextField
								label={lang.webviewFlow.lastName}
								required
								field={field}
								error={invalid}
								errorMessage={error?.message}
								inputProps={{ maxLength: 32, 'data-testid': 'last-name-input' }}
							/>
						</StyledGridContainerForTextFields>
					)}
				/>

				{dropdownFieldNames.map((fieldName) =>
					fieldNameToValidationMap[fieldName] === 'store' ? (
						<Controller
							key={fieldName}
							control={control}
							name={fieldNameToValidationMap[fieldName]}
							defaultValue=""
							render={({ field, fieldState: { invalid, error } }) => (
								<StyledGridContainerForTextFields item xs={12} sm={12} md={12}>
									<AutocompleteWithDropdown
										label={fieldName}
										options={storeList}
										field={field}
										error={invalid}
										helperText={error?.message}
										name={fieldNameToValidationMap[fieldName]}
										setValue={setValue}
										testId={fieldName?.replaceAll(' ', '-').toLowerCase()}
									/>
								</StyledGridContainerForTextFields>
							)}
						/>
					) : (
						<Controller
							key={fieldName}
							control={control}
							name={fieldNameToValidationMap[fieldName]}
							defaultValue=""
							render={({ field, fieldState: { invalid, error } }) => (
								<StyledGridContainerForTextFields item xs={12} sm={12} md={12} key={fieldName}>
									<Dropdown
										label={fieldName}
										fullWidth
										fieldheight={34}
										ignoreRTL
										isContactUs
										options={dropdownOptions[fieldName]}
										field={field}
										error={invalid}
										helperText={error?.message}
										name={fieldNameToValidationMap[fieldName]}
										setValue={setValue}
										testId={fieldName?.replaceAll(' ', '-').toLowerCase()}
									/>
								</StyledGridContainerForTextFields>
							)}
						/>
					)
				)}

				<Controller
					control={control}
					name="yourMessage"
					defaultValue=""
					render={({ field, fieldState: { invalid, error } }) => (
						<StyledGridContainerForTextFields item xs={12} sm={12} md={12}>
							<TextField
								label={`${lang.webviewFlow.yourMessage} *`}
								field={field}
								error={invalid}
								errorMessage={error?.message}
								inputProps={{ maxLength: 10000 }}
								multiline
								minRows={4}
								inputProps={{
									'data-testid': 'your-message-input',
								}}
							/>
						</StyledGridContainerForTextFields>
					)}
				/>

				<StyledGridContainerForTextFields item xs={12} sm={12} md={12}>
					<Upload
						control={control}
						setValue={setValue}
						setError={setError}
						errorText={lang.webviewFlow.attachmentsError}
						uploadBtnText={lang.webviewFlow.pleaseUploadReceipt}
						attachmentText={lang.webviewFlow.attachments}
					/>
				</StyledGridContainerForTextFields>
			</StyledFieldsContainer>

			<StyledSubTitleGrid item xs={12} sm={12} md={12}>
				<StyledDisclaimer variant="BodyRegular">{lang.webviewFlow.gdprDisclaimer}</StyledDisclaimer>
			</StyledSubTitleGrid>
		</>
	)
}

export default ContactUsForm
